import styled from 'styled-components';

export const Wrapper = styled.button`
    width: 30px;
    height: 30px;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    border: none;
    cursor: pointer;

    transition:
        background-color 200ms ease,
        color 200ms ease;
    color: rgba(255, 255, 255, 0.5);

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;

    &:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.15);
    }
`;
